import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import MenuDataIntelligence from "../MenuDataIntelligence";
import PesquisaArtigo from "../PesquisaArtigo";

export default function FileImport() {
  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/data-intelligence">Data Intelligence</a>
                  </li>
                  <li className="breadcrumb-item active">
                    O que é Enriquecimento de Dados?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataIntelligence />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                O que é Enriquecimento de Dados?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Intelligence</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Enriquecimento de Dados
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>
                <p>
                  Enriquecimento de dados é o processo de aprimorar ou melhorar
                  a qualidade e quantidade de informações presentes em um
                  conjunto de dados específico. Geralmente, isso é alcançado
                  através da adição de dados externos e complementares ao
                  conjunto original.{" "}
                </p>
                <p>
                  O objetivo principal é aumentar a utilidade e a precisão dos
                  dados, permitindo que sejam mais valiosos para análises,
                  tomadas de decisão e outras aplicações.{" "}
                </p>
                <p>
                  É comumente aplicado em diversas áreas, incluindo marketing,
                  análise de dados, gerenciamento de relacionamento com clientes
                  (CRM), prevenção de fraudes, pesquisa de mercado e muito mais.{" "}
                </p>
                <p>
                  O enriquecimento de dados da <a> </a>
                  <a href="https://salesbox.com.br/" target="blank">
                    {" "}
                    Sales Box{""}
                  </a>
                  <a> </a>permite: Anexação de Dados, Normalização/Satinitização
                  de Dados, Correção de atualização de Dados e Enriquecimento
                  geográfico. <a> </a>
                  <a href="/como-enriquecer-meus-dados" target="blank">
                    {" "}
                    Entenda aqui{""}
                  </a>
                  <a> </a>como enriquecer seus dados.
                </p>
              </div>

              <br></br>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
